/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-06 11:39:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import { Badge, Card, SkeletonDisplayText, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import SourceProductItem from 'src/components/views/recommendation/manual-recommendation/item/source-product-item';
import NoProduct from 'src/components/views/recommendation/manual-recommendation/item/no-product';
import type { Product } from 'src/models/product';

type Props = {
  sourceProducts: Product[],
  isHiddenAdd: boolean,
  isLoading: boolean,
  onToggleModal: (modal: string) => void,
  onRemove: (product: Product) => void
};

type ComposedProps = WithI18nProps & Props;

class SourceProduct extends Component<ComposedProps> {
  render() {
    const { i18n, isHiddenAdd, onToggleModal } = this.props;
    return (
      <div className="BC-Page__ManualRecommendationNew__SourceProduct">
        <Card
          sectioned
          title={
            <div>
              <div>
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Recommendation.ManualRecommendation.AddNew.sourceProduct_Title'
                  )}
                </TextStyle>
                <span style={{ marginLeft: '0.25rem' }}>
                  <Badge status="info">
                    {i18n.translate(
                      'AdminHTML.Recommendation.ManualRecommendation.AddNew.sourceProduct_Badge'
                    )}
                  </Badge>
                </span>
              </div>
              <div>
                <TextStyle variation="subdued">
                  {i18n.translate(
                    'AdminHTML.Recommendation.ManualRecommendation.AddNew.sourceProduct_Subtitle'
                  )}
                </TextStyle>
              </div>
            </div>
          }
          actions={
            isHiddenAdd
              ? null
              : [
                  {
                    content: i18n.translate(
                      'AdminHTML.Recommendation.ManualRecommendation.AddNew.addProduct'
                    ),
                    onAction: onToggleModal
                  }
                ]
          }>
          {this.renderContent()}
        </Card>
      </div>
    );
  }

  renderContent = () => {
    const { isLoading, sourceProducts, isHiddenAdd, onRemove } = this.props;
    if (isLoading) {
      return (
        <div className="BC-Page__ManualRecommendationNew__SourceProduct__Skeleton">
          <SkeletonDisplayText size="medium" />
        </div>
      );
    }

    if (_.isEmpty(sourceProducts)) {
      return <NoProduct />;
    }

    return (
      <ul className="BC-Page__ManualRecommendationNew__SourceProduct__List">
        {sourceProducts.map(product => (
          <li key={product.id}>
            <SourceProductItem product={product} onRemove={onRemove} isHiddenRemove={isHiddenAdd} />
          </li>
        ))}
      </ul>
    );
  };
}

SourceProduct.defaultProps = {
  isHiddenAdd: false
};

export default withI18n()(SourceProduct);
